import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

const API_URL = "https://comoticket-production.up.railway.app/api";

export default function CustomerAuthPage() {
  const [mode, setMode] = useState("login");
  const [form, setForm] = useState({ name: "", email: "", phone: "", password: "" });
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [resetEmail, setResetEmail] = useState("");
  const [resetCustomerId, setResetCustomerId] = useState(null);
  const [resetCode, setResetCode] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const endpoint = mode === "login" ? "/customer/login" : "/customer/register";
      const res = await fetch(API_URL + endpoint, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form),
      });
      const data = await res.json();
      if (!res.ok) {
        setError(data.error || "Une erreur est survenue");
        setLoading(false);
        return;
      }
      localStorage.setItem("comoticket_customer_token", data.token);
      localStorage.setItem("comoticket_customer", JSON.stringify(data.customer));
      navigate("/compte/mes-billets");
    } catch (err) {
      setError("Erreur de connexion au serveur");
    } finally {
      setLoading(false);
    }
  };

  const handleForgotPassword = async (e) => {
    e.preventDefault();
    setError(""); setSuccess(""); setLoading(true);
    try {
      const res = await fetch(API_URL + "/customer/forgot-password", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: resetEmail }),
      });
      const data = await res.json();
      if (!res.ok) { setError(data.error || "Une erreur est survenue"); setLoading(false); return; }
      setResetCustomerId(data.customer_id || null);
      setMode("reset-code");
      setSuccess("Code envoye par email si ce compte existe");
    } catch (err) {
      setError("Erreur de connexion au serveur");
    } finally {
      setLoading(false);
    }
  };

  const handleResetPassword = async (e) => {
    e.preventDefault();
    setError("");
    if (newPassword !== confirmPassword) {
      setError("Les mots de passe ne correspondent pas");
      return;
    }
    setLoading(true);
    try {
      const res = await fetch(API_URL + "/customer/reset-password", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ customer_id: resetCustomerId, code: resetCode, new_password: newPassword }),
      });
      const data = await res.json();
      if (!res.ok) { setError(data.error || "Une erreur est survenue"); setLoading(false); return; }
      setMode("login");
      setSuccess("Mot de passe reinitialise, vous pouvez vous connecter");
      setForm({...form, email: resetEmail, password: ""});
    } catch (err) {
      setError("Erreur de connexion au serveur");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{minHeight:"100vh",background:"#0a0a0a",fontFamily:"'Inter',Arial,sans-serif",color:"white"}}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800;900&display=swap');
        * { box-sizing: border-box; margin: 0; padding: 0; }
        .form-input { width: 100%; padding: 14px 16px; background: rgba(255,255,255,0.05); border: 1.5px solid rgba(255,255,255,0.1); border-radius: 12px; color: white; font-size: 14px; font-family: inherit; outline: none; transition: border-color 0.2s; }
        .form-input:focus { border-color: #2563eb; background: rgba(37,99,235,0.05); }
        .form-input::placeholder { color: rgba(255,255,255,0.25); }
      `}</style>

      <nav style={{position:"sticky",top:0,zIndex:100,background:"rgba(10,10,10,0.95)",backdropFilter:"blur(20px)",borderBottom:"1px solid rgba(255,255,255,0.06)",padding:"16px 40px",display:"flex",alignItems:"center",justifyContent:"space-between"}}>
        <a href="/events" style={{display:"flex",alignItems:"center",gap:10,textDecoration:"none"}}>
          <div style={{width:36,height:36,background:"#2563eb",borderRadius:10,display:"flex",alignItems:"center",justifyContent:"center",fontSize:18,fontWeight:800,color:"white"}}>C</div>
          <span style={{fontSize:18,fontWeight:800,letterSpacing:"-0.5px",color:"white"}}>ComoTicket</span>
        </a>
        <a href="/events" style={{color:"rgba(255,255,255,0.5)",fontSize:13,textDecoration:"none"}}>&larr; Retour aux &eacute;v&eacute;nements</a>
      </nav>

      <div style={{maxWidth:420,margin:"0 auto",padding:"60px 40px"}}>
        <h1 style={{fontSize:28,fontWeight:800,letterSpacing:"-1px",marginBottom:8}}>
          <span dangerouslySetInnerHTML={{__html: mode === "login" ? "Mon espace" : mode === "register" ? "Cr&eacute;er mon compte" : mode === "forgot" ? "Mot de passe oubli&eacute;" : "Nouveau mot de passe"}} />
        </h1>
        <p style={{fontSize:14,color:"rgba(255,255,255,0.5)",marginBottom:32}}>
          <span dangerouslySetInnerHTML={{__html: mode === "login" ? "Connectez-vous pour retrouver vos billets" : mode === "register" ? "Cr&eacute;ez un compte pour retrouver vos billets facilement" : mode === "forgot" ? "Entrez votre email pour recevoir un code" : "Entrez le code re&ccedil;u et votre nouveau mot de passe"}} />
        </p>

        {error && <div style={{background:"rgba(239,68,68,0.1)",border:"1px solid rgba(239,68,68,0.3)",color:"#fca5a5",borderRadius:10,padding:"10px 14px",fontSize:13,marginBottom:20}} dangerouslySetInnerHTML={{__html: error}} />}
        {success && <div style={{background:"rgba(16,185,129,0.1)",border:"1px solid rgba(16,185,129,0.3)",color:"#6ee7b7",borderRadius:10,padding:"10px 14px",fontSize:13,marginBottom:20}} dangerouslySetInnerHTML={{__html: success}} />}

        {mode === "forgot" && (
          <form onSubmit={handleForgotPassword}>
            <div style={{marginBottom:24}}>
              <label style={{fontSize:12,fontWeight:600,color:"rgba(255,255,255,0.5)",display:"block",marginBottom:8}}>Email de votre compte</label>
              <input type="email" className="form-input" placeholder="vous@email.com" value={resetEmail} onChange={e => setResetEmail(e.target.value)} required />
            </div>
            <button type="submit" disabled={loading} style={{width:"100%",background:"#2563eb",border:"none",color:"white",padding:"14px",borderRadius:12,fontWeight:700,fontSize:15,cursor:"pointer",opacity:loading?0.7:1}}>
              {loading ? "Envoi..." : "Recevoir un code"}
            </button>
            <div style={{textAlign:"center",marginTop:20}}>
              <button type="button" onClick={() => {setMode("login"); setError(""); setSuccess("");}} style={{background:"none",border:"none",color:"#60a5fa",fontWeight:700,cursor:"pointer",fontSize:13}}>&larr; Retour &agrave; la connexion</button>
            </div>
          </form>
        )}

        {mode === "reset-code" && (
          <form onSubmit={handleResetPassword}>
            <div style={{marginBottom:16}}>
              <label style={{fontSize:12,fontWeight:600,color:"rgba(255,255,255,0.5)",display:"block",marginBottom:8}}>Code re&ccedil;u par email</label>
              <input type="text" className="form-input" placeholder="123456" value={resetCode} onChange={e => setResetCode(e.target.value.replace(/[^0-9]/g,"").slice(0,6))} style={{fontSize:20,letterSpacing:6,textAlign:"center",fontWeight:700}} maxLength={6} required />
            </div>
            <div style={{marginBottom:16}}>
              <label style={{fontSize:12,fontWeight:600,color:"rgba(255,255,255,0.5)",display:"block",marginBottom:8}}>Nouveau mot de passe</label>
              <div style={{position:"relative"}}>
                <input type={showNewPassword ? "text" : "password"} className="form-input" placeholder="********" value={newPassword} onChange={e => setNewPassword(e.target.value)} style={{paddingRight:44}} required />
                <button type="button" onClick={() => setShowNewPassword(!showNewPassword)} style={{position:"absolute",right:12,top:"50%",transform:"translateY(-50%)",background:"none",border:"none",cursor:"pointer",fontSize:16,padding:4,filter:"invert(1) brightness(2)"}} dangerouslySetInnerHTML={{__html: showNewPassword ? "&#128584;" : "&#128065;"}} />
              </div>
            </div>
            <div style={{marginBottom:24}}>
              <label style={{fontSize:12,fontWeight:600,color:"rgba(255,255,255,0.5)",display:"block",marginBottom:8}}>Confirmer le mot de passe</label>
              <div style={{position:"relative"}}>
                <input type={showNewPassword ? "text" : "password"} className="form-input" placeholder="********" value={confirmPassword} onChange={e => setConfirmPassword(e.target.value)} style={{paddingRight:44}} required />
                <button type="button" onClick={() => setShowNewPassword(!showNewPassword)} style={{position:"absolute",right:12,top:"50%",transform:"translateY(-50%)",background:"none",border:"none",cursor:"pointer",fontSize:16,padding:4,filter:"invert(1) brightness(2)"}} dangerouslySetInnerHTML={{__html: showNewPassword ? "&#128584;" : "&#128065;"}} />
              </div>
            </div>
            <button type="submit" disabled={loading || resetCode.length !== 6} style={{width:"100%",background:"#2563eb",border:"none",color:"white",padding:"14px",borderRadius:12,fontWeight:700,fontSize:15,cursor:"pointer",opacity:loading?0.7:1}} dangerouslySetInnerHTML={{__html: loading ? "Validation..." : "R&eacute;initialiser le mot de passe"}} />
            <div style={{textAlign:"center",marginTop:20}}>
              <button type="button" onClick={() => {setMode("login"); setError(""); setSuccess("");}} style={{background:"none",border:"none",color:"#60a5fa",fontWeight:700,cursor:"pointer",fontSize:13}}>&larr; Retour &agrave; la connexion</button>
            </div>
          </form>
        )}

        {(mode === "login" || mode === "register") && (
          <form onSubmit={handleSubmit}>
            {mode === "register" && (
              <div style={{marginBottom:16}}>
                <label style={{fontSize:12,fontWeight:600,color:"rgba(255,255,255,0.5)",display:"block",marginBottom:8}}>Nom complet</label>
                <input className="form-input" placeholder="Votre nom" value={form.name} onChange={e => setForm({...form,name:e.target.value})} required />
              </div>
            )}
            <div style={{marginBottom:16}}>
              <label style={{fontSize:12,fontWeight:600,color:"rgba(255,255,255,0.5)",display:"block",marginBottom:8}}>Email</label>
              <input type="email" className="form-input" placeholder="vous@email.com" value={form.email} onChange={e => setForm({...form,email:e.target.value})} required />
            </div>
            {mode === "register" && (
              <div style={{marginBottom:16}}>
                <label style={{fontSize:12,fontWeight:600,color:"rgba(255,255,255,0.5)",display:"block",marginBottom:8}}>T&eacute;l&eacute;phone (optionnel)</label>
                <input className="form-input" placeholder="+269..." value={form.phone} onChange={e => setForm({...form,phone:e.target.value})} />
              </div>
            )}
            <div style={{marginBottom:24}}>
              <label style={{fontSize:12,fontWeight:600,color:"rgba(255,255,255,0.5)",display:"block",marginBottom:8}}>Mot de passe</label>
              <div style={{position:"relative"}}>
                <input type={showPassword ? "text" : "password"} className="form-input" placeholder="********" value={form.password} onChange={e => setForm({...form,password:e.target.value})} style={{paddingRight:44}} required />
                <button type="button" onClick={() => setShowPassword(!showPassword)} style={{position:"absolute",right:12,top:"50%",transform:"translateY(-50%)",background:"none",border:"none",cursor:"pointer",fontSize:16,padding:4,filter:"invert(1) brightness(2)"}} dangerouslySetInnerHTML={{__html: showPassword ? "&#128584;" : "&#128065;"}} />
              </div>
            </div>
            <button type="submit" disabled={loading} style={{width:"100%",background:"#2563eb",border:"none",color:"white",padding:"14px",borderRadius:12,fontWeight:700,fontSize:15,cursor:"pointer",opacity:loading?0.7:1}}>
              <span dangerouslySetInnerHTML={{__html: loading ? "Chargement..." : mode === "login" ? "Se connecter" : "Cr&eacute;er mon compte"}} />
            </button>
            {mode === "login" && (
              <div style={{textAlign:"center",marginTop:16}}>
                <button type="button" onClick={() => {setMode("forgot"); setError(""); setSuccess(""); setResetEmail(form.email);}} style={{background:"none",border:"none",color:"rgba(255,255,255,0.4)",fontSize:12,cursor:"pointer"}}>Mot de passe oubli&eacute; ?</button>
              </div>
            )}
          </form>
        )}

        {(mode === "login" || mode === "register") && (
          <div style={{textAlign:"center",marginTop:24,fontSize:13,color:"rgba(255,255,255,0.4)"}}>
            {mode === "login" ? (
              <>Pas encore de compte ? <button onClick={() => {setMode("register"); setError(""); setSuccess("");}} style={{background:"none",border:"none",color:"#60a5fa",fontWeight:700,cursor:"pointer",fontSize:13}}>Cr&eacute;er un compte</button></>
            ) : (
              <>D&eacute;j&agrave; un compte ? <button onClick={() => {setMode("login"); setError(""); setSuccess("");}} style={{background:"none",border:"none",color:"#60a5fa",fontWeight:700,cursor:"pointer",fontSize:13}}>Se connecter</button></>
            )}
          </div>
        )}
      </div>
    </div>
  );
}